import { getMomentTz } from "@dexteel/mesf-core";
import { ColDef } from "ag-grid-community";
import { withFraction32 } from "@/utils/fraction";

const moment = getMomentTz();

export const useBundlesTableData = () => {
	const columnDefs: ColDef[] = [
		{
			field: "ProductCode",
			headerName: "Program",
			flex: 1,
			minWidth: 75,
		},
		{
			field: "StartTime",
			headerName: "Start",
			valueFormatter: (params) => {
				if (params.value) {
					return moment(params.value).format("MM/DD HH:mm");
				}
				return "";
			},
			flex: 1,
			minWidth: 105,
		},
		{
			field: "EndTime",
			headerName: "End",
			valueFormatter: (params) => {
				if (params.value) {
					return moment(params.value).format("MM/DD HH:mm");
				}
				return "";
			},
			flex: 1,
			minWidth: 105,
		},
		{
			field: "DurationMinutes",
			headerName: "Duration",
			valueFormatter: (params) => {
				if (params.value != null) {
					return `${params.value}m`;
				}
				return "";
			},
			flex: 1,
			minWidth: 76,
		},
		{
			field: "BarCount",
			headerName: "Pieces",
			flex: 1,
			minWidth: 60,
		},
		{
			field: "LayerCount",
			headerName: "Layers",
			flex: 1,
			minWidth: 65,
		},
		{
			field: "AvgLength",
			headerName: "Avg Length",
			valueFormatter: (params) => withFraction32(params.value),
			flex: 1,
			minWidth: 66,
			wrapHeaderText: true,
		},
		{
			field: "MinLength",
			headerName: "Min Length",
			valueFormatter: (params) => withFraction32(params.value),
			flex: 1,
			minWidth: 66,
			wrapHeaderText: true,
		},
		{
			field: "MaxLength",
			headerName: "Max Length",
			valueFormatter: (params) => withFraction32(params.value),
			flex: 1,
			minWidth: 66,
			wrapHeaderText: true,
		},
		{
			field: "LengthStdDev",
			headerName: "Std Dev %",
			valueFormatter: (params) => {
				if (params.value != null) {
					return `${Number(params.value).toFixed(3)}%`;
				}
				return "";
			},
			flex: 1,
			minWidth: 69,
			wrapHeaderText: true,
		},
		{
			field: "TooLong",
			headerName: "Too Long",
			valueFormatter: (params) => (params.value > 0 ? params.value : ""),
			flex: 1,
			minWidth: 60,
			wrapHeaderText: true,
		},
		{
			field: "TooShort",
			headerName: "Too Short",
			valueFormatter: (params) => (params.value > 0 ? params.value : ""),
			flex: 1,
			minWidth: 60,
			wrapHeaderText: true,
		},
		{
			field: "BadBars",
			headerName: "Bad Pieces",
			valueFormatter: (params) => (params.value > 0 ? params.value : ""),
			flex: 1,
			minWidth: 60,
			wrapHeaderText: true,
		},
		{
			field: "RejectionRatePct",
			headerName: "Rej %",
			valueFormatter: (params) => {
				if (params.value != null) {
					return `${Number(params.value).toFixed(1)}%`;
				}
				return "";
			},
			flex: 1,
			minWidth: 60,
		},
	];

	return { columnDefs };
};
